import React from 'react';

const ShopIcon = ({
  size = 24,
  color = 'currentColor',
  className = '',
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      className={className}
      {...props}
    >
      <path
        d="M19 13c.7 0 1.37.13 2 .35V12l-1-5H4l-1 5v2h1v6h9.09c-.05-.33-.09-.66-.09-1c0-1.23.37-2.36 1-3.31V14h1.69c.95-.63 2.08-1 3.31-1m-7 5H6v-4h6zm-6.96-6l.6-3h12.72l.6 3zM20 6H4V4h16zm2.5 11.25L17.75 22L15 19l1.16-1.16l1.59 1.59l3.59-3.59z"
        fill={color}
      />
    </svg>
  );
};

export default ShopIcon;
